import { ThemeProvider } from "styled-components";
import { useState, useEffect } from "react";
import { darkTheme, lightTheme } from './utils/Themes.js';
import SecureTracker from './utils/SecureTracker.js';
import Navbar from "./components/Navbar";
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import styled from "styled-components";
import Loader from "./components/Loader";
import EmailCapture from "./components/EmailCapture";
import ProjectsComingSoon from "./components/ProjectsComingSoon";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
`

const Wrapper = styled.div`
  background: linear-gradient(38.73deg, rgba(204, 0, 187, 0.15) 0%, rgba(201, 32, 184, 0) 50%), linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%,30% 98%, 0 100%);
`

function App() {
  const [darkMode] = useState(true);
  const [loading, setLoading] = useState(true); // Loading state
  const [openModal, setOpenModal] = useState({ state: false, project: null });
  const [showProjectsModal, setShowProjectsModal] = useState(false);
  console.log(openModal)


  // Simulate loading data and track visitor
  useEffect(() => {
    const timer = setTimeout(async () => {
      setLoading(false);
      // Track visitor after loading is complete
      const visitorInfo = await import('./utils/VisitorTracker.js');
      const info = await visitorInfo.default.getVisitorInfo();
      SecureTracker.trackVisit(info);
    }, 3000); // Change to your desired loading duration

    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router >
        {
          loading ? <Loader /> : (
            <>
              <Navbar onProjectsClick={() => setShowProjectsModal(true)} />
              <Body>
                <HeroSection />
                <Wrapper>
                  <Skills />
                  <Experience />
                </Wrapper>
                {/* <Projects openModal={openModal} setOpenModal={setOpenModal} /> */}
                <Wrapper>
                  <Education />
                  <Contact />
                </Wrapper>
                <Footer onProjectsClick={() => setShowProjectsModal(true)} />
                {openModal.state &&
                  <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
                }
              </Body>
              <EmailCapture />
              <ProjectsComingSoon 
                isOpen={showProjectsModal} 
                onClose={() => setShowProjectsModal(false)} 
              />
            </>
          )}
      </Router>
    </ThemeProvider>
  );
}

export default App;
